<template>
  <div class="special-item">
    <div @click.prevent="mouseClick">
      <img :src="imgUrl" alt="wait" height="284" width="100%" />
      <div style="padding:0px 10px">
        <div style="margin-top:10px">
          <span class="special-flag">专题</span>
          <span class="special-title">{{ title }}</span>
        </div>
        <div class="subjectDescri" style>{{object.description}}</div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    id: {
      required: true
    },
    title: {
      type: String,
      default: null
    },
    img: {
      type: String,
      default: null
    },
    object: {
      type: Object,
      default: {}
    }
  },
  computed: {
    imgUrl: function() {
      return this.img;
    }
  },

  methods: {
    mouseClick() {
      this.$emit("box-click", this.object);
    }
  }
};
</script>

<style lang="less">
.special-item {
  position: relative;
  border: 1px solid #dcdbdb;
  box-shadow: 2px 2px #fcfcfc;
  div {
    .special-flag {
      background-color: #2bbdf0;
      color: white;
      padding: 0.2rem 0.4rem;
      font-size: 1.3rem;
      border-radius: 0.3rem;
    }
    .special-title {
      font-size: 1.3rem;
      font-weight: bold;
      padding: 0 1rem 0rem 0.4rem;
      cursor: pointer;
      &:hover {
        color: orange;
      }
    }
    .subjectDescri {
      text-align: left;
      margin-top: 10px;
      margin-bottom: 10px;
      word-break: break-all;
      text-overflow: ellipsis;
      display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
      -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
      -webkit-line-clamp: 1; /** 显示的行数 **/
      overflow: hidden; /** 隐藏超出的内容 **/
      height: 20px;
    }
  }
}
</style>

